<template>
  <div class="a7-painel-avaliacao">
    <gw-donut :donutColumns="donutColumns" :donutColors="donutColors" legend-position="right"
      :tooltipFormat="donutTooltipFormat" :tooltip-position="donutTooltipPosition"
      size="big"/>
  </div>
</template>
<script>
import MedicaoIndicadorRestResource from './MedicaoIndicadorRestResource'
import {
  GwDonut,
  Formatters,
  FilterUtilities
} from 'guaxinim-web'
import {cores} from './A7PainelDefaultConfigurations'

export default {
  name: "a7-painel-avaliacao",
  components: {
    GwDonut,
    Formatters,
    FilterUtilities
  },
  props: {
    entity: {
      type: Object,
      default: {}
    },
    filterParams: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    avaliacao: null,
    donutColumns: [],
    donutColors: {
      'Não se aplica': cores.corNaoSeAplica,
      'Erro': cores.corErro,
      'Péssimo': cores.corPessimo,
      'Ruim': cores.corRuim,
      'Bom': cores.corBom,
      'Ótimo': cores.corOtimo,
      'Excelente': cores.corExcelente
    }
  }),
  methods: {
    donutTooltipPosition(data, width, height, element) {
      const top = d3.mouse(element)[1] + 50
      const left = d3.mouse(element)[0] + 50
      return {top, left}
    },
    donutTooltipFormat(value) {
      return Formatters.percentFormat.format(value)
    },
    setDonutColumns(avaliacao, entity) {
      if (!avaliacao || !entity) return

      const total =
        entity.contagemDesempenho + avaliacao.avaliacaoNaoSeAplica + avaliacao.avaliacaoErro
      const razao = (1 / total) * 100

      const naoSeAplica = avaliacao.avaliacaoNaoSeAplica * razao
      const erro = avaliacao.avaliacaoErro * razao
      const pessimo = avaliacao.avaliacaoPessimo * razao
      const ruim = avaliacao.avaliacaoRuim * razao
      const bom = avaliacao.avaliacaoBom * razao
      const otimo = avaliacao.avaliacaoOtimo * razao
      const excelente = avaliacao.avaliacaoExcelente * razao

      this.donutColumns = [
        ['Péssimo', pessimo],
        ['Ruim', ruim],
        ['Bom', bom],
        ['Ótimo', otimo],
        ['Excelente', excelente],
        ['Erro', erro],
        ['Não se aplica', naoSeAplica]
      ]
    },
    buscarDadosAvaliacao(entity) {
      if (!entity) return;

      const dtoPainel = JSON.parse(JSON.stringify(entity))
      dtoPainel.filhos = null
      MedicaoIndicadorRestResource.findAvaliacao(
        FilterUtilities.createFilterParamsString(this.filterParams),
        JSON.stringify(dtoPainel)
      )
        .then(avaliacao => this.setDonutColumns(avaliacao, entity))
        .catch(err => this.$gw.defaultExceptionHandler.handleUnknownException(err, this))
    },
  },
  watch: {
    entity(newValue){
      this.buscarDadosAvaliacao(newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
